import Avatar from "@mui/material/Avatar";
import Button from "@mui/material/Button";
import Chip from "@mui/material/Chip";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import Typography from "@mui/material/Typography";
import { useNavigate } from "react-router-dom";

const renderStatus = (label: string, status: string) => {
  let statusColor = { color: "", background: "" };

  if (status === "pending") {
    statusColor = { color: "#FF8652", background: "rgba(255, 134, 82, 0.1)" };
  }

  if (status === "open") {
    statusColor = { color: "#2858D3", background: "rgba(40, 88, 211, 0.1)" };
  }

  if (status === "replied") {
    statusColor = { color: "#3EB458", background: "rgba(62, 180, 88, 0.1)" };
  }

  if (status === "closed") {
    statusColor = { color: "#A0A5B1", background: "rgba(160, 165, 177, 0.1)" };
  }

  return (
    <Chip
      label={label}
      sx={{
        textTransform: "uppercase",
        ...statusColor,
      }}
    />
  );
};

const FeedBackMetricTableRows = ({
  reportsTicketsData,
}: {
  reportsTicketsData: any;
}) => {
  const navigate = useNavigate();

  const handleRedirectTickets = (topic: any) => {
    // navigate("/tickets");
    const stateObj = {
      pageType: "mainReportPage",
      topic: topic,
    };
    navigate(`/view-tickets/${topic}`, { state: stateObj });
  };

  const handleRedirectTicketDetails = () => {
    navigate(`/tickets-details/${12345}`);
  };

  const renderStatusCount = (data: any, type: any) => {
    let count = 0;

    if (data && data.statusCounts && data.statusCounts.length > 0) {
      const resp = data.statusCounts.filter((e: any) => e.status == type);
      if (resp && resp.length > 0) {
        count = resp[0].ticketCount;
      }

      // data.statusCounts.map((type: any) => {
      //   if (type.status == "open") {
      //     count = type.ticketCount;
      //   }
      // });
      return count;
    }
  };

  return (
    <TableRow>
      <TableCell
        sx={
          {
            // cursor: "pointer",
          }
        }
        // onClick={handleRedirectTicketDetails}
      >
        <Typography
          sx={{
            fontWeight: 500,
            fontSize: "0.8rem",
          }}
        >
          {reportsTicketsData.topic}
        </Typography>

        <Typography
          sx={{
            color: "rgba(0, 0, 0, 0.5)",
            fontWeight: 400,
            fontSize: "0.8rem",
          }}
        >
          Total Tickets: {reportsTicketsData.totalTicketCount}
        </Typography>
      </TableCell>
      {/* <TableCell align="center">{renderStatus("open", "open")}</TableCell>
      <TableCell align="center">{renderStatus("replied", "replied")}</TableCell>
      <TableCell align="center">{renderStatus("closed", "closed")}</TableCell> */}

      <TableCell align="center">
        {renderStatusCount(reportsTicketsData, "open")}
      </TableCell>
      <TableCell align="center">
        {renderStatusCount(reportsTicketsData, "pending response")}
      </TableCell>
      <TableCell align="center">
        {" "}
        {renderStatusCount(reportsTicketsData, "replied")}
      </TableCell>
      <TableCell align="center">
        {" "}
        {renderStatusCount(reportsTicketsData, "closed")}
      </TableCell>

      <TableCell align="right">
        <Avatar
          sx={{
            fontSize: "11px",
            background: "#2858D3",
            display: "inline-flex",
            border: "1px solid #FFF",
          }}
        >
          {reportsTicketsData.totalUserCount}
        </Avatar>
      </TableCell>
      <TableCell align="right">
        <Avatar
          sx={{
            fontSize: "11px",
            background: "#2858D3",
            display: "inline-flex",
            border: "1px solid #FFF",
          }}
        >
          {reportsTicketsData.reviewCounts}
        </Avatar>
      </TableCell>
      <TableCell align="right">
        <Button
          variant="text"
          sx={{
            fontSize: 12,
            color: "#2858D3",
            fontWeight: 700,
            marginLeft: 0,
            padding: 0,
          }}
          // onClick={handleRedirectTickets}
          onClick={() => handleRedirectTickets(reportsTicketsData.topic)}
        >
          View Tickets
        </Button>
      </TableCell>
    </TableRow>
  );
};

export default FeedBackMetricTableRows;
